import {getLanguage} from '../../../../_shared/GWTBridge/invoke/common';
import {Search as SearchType} from 'priority-web-sdk/enums';

export type Direction = 'ltr' | 'rtl' | 'auto';

export function getItemValue(item): string {
    return item.retval || item.string1 || '';
}

export function getItemDesc(item) {
    return item.retval === item.string1 ? item.string2 : item.string1;
}

export function convertItemToTag(item) {
    return {value: getItemValue(item), desc: getItemDesc(item)};
}

export function getSelectedItem(results, searchQuery, isSearchable) {
    if (results.length && searchQuery) {
        const lowercaseSearchQuery = searchQuery.toLowerCase();
        const index = isSearchable
            ? getSelectedIndexOnSearchable(results, lowercaseSearchQuery)
            : getSelectedIndexOnNotSearchable(results, lowercaseSearchQuery, true);
        return index !== undefined && results[index];
    }
}

function getSelectedIndexOnSearchable(results, searchQuery) {
    let selectedIndex;

    for (let i = 0; i < results.length; i++) {
        const str1 = results[i].string1 && results[i].string1.toLowerCase();
        const str2 = results[i].string2 && results[i].string2.toLowerCase();
        const str3 = results[i].string3 && results[i].string3.toLowerCase();

        if (str1 === searchQuery || str2 === searchQuery || str3 === searchQuery) {
            //if there is more than 1 exact equal result
            if (selectedIndex !== undefined) return null;

            selectedIndex = i;
        }
    }
    return selectedIndex;
}

function getSelectedIndexOnNotSearchable(results, searchQuery, exact = false) {
    let selectedIndex;

    for (let i = 0; i < results.length; i++) {
        const str1 = results[i].string1 && results[i].string1.toLowerCase();

        //if found an equal item to the search query.
        if (str1 === searchQuery) {
            return i;
        }

        if (!exact && selectedIndex === undefined && str1?.startsWith(searchQuery.trim())) {
            selectedIndex = i;
        }
    }
    return selectedIndex;
}

export function getFocusedIndex(results, searchQuery, isSearchable, isMulti) {
    let focusedIndex;
    if (!results?.length || isMulti) {
        return -1;
    }
    if (results.length && searchQuery) {
        const lowercaseSearchQuery = searchQuery.toLowerCase();
        focusedIndex = isSearchable
            ? getSelectedIndexOnSearchable(results, lowercaseSearchQuery)
            : getSelectedIndexOnNotSearchable(results, lowercaseSearchQuery);
    }
    return focusedIndex !== undefined ? focusedIndex : isSearchable ? -1 : 0;
}

export function showSearchQueryInResults(searchQuery, isNoResults = false) {
    return searchQuery !== '' && (isNoResults || /(\*|_|\?)/.test(searchQuery));
}

export function calculateInputDirection(result: SearchType) {
    const lang = getLanguage();
    if (result.cursor && lang === 1) {
        return result.alignright === '1' ? 'rtl' : 'ltr';
    }
    return 'auto';
}
